      <p>
        Administrators:
      </p><br>
      <br>
      <div *ngFor="let contact of contact_session" >
        <u>{{contact.full_name}}</u><br>
        Office Phone: {{contact.office_phone | mask: '000-000-0000'}}<br>
        Cell Phone: {{contact.cell_phone | mask: '000-000-0000'}}<br>
        Email:<u class="email">{{contact.email}}</u><br>
      </div>